import documentApiClient, { ApiDefinition } from '@documentsApi';

type ThisApi = ApiDefinition['/document-request-users/{id}/modal']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const updateDocumentRequestUserForModalState= async ({ id, ...body }: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.put(`/document-request-users/${id}/modal`, body);
  return response.data;
};

export default updateDocumentRequestUserForModalState;
